export default {
  setLastBestOrderList(state, list) {
    state.lastBest.list = [...state.lastBest.list, ...list];
    // state.lastBest.pageInfo = responseData.pageInfo;
  },

  setLastBestOrderPage(state, page = 1) {
    state.lastBest.page = page;
  },

  setLastBestOrderTotalPage(state, totalPage = 2) {
    state.lastBest.totalPage = totalPage;
  },

  initLastBestOrder(state) {
    state.lastBest.page = 1;
    state.lastBest.totalPage = 2;
    state.lastBest.list = [];
  },

  setDetail(state, data) {
    state.detail = data;
  },

  setMyOrderList: (state, list = []) => {
    state.myOrder.list = [...state.myOrder.list, ...list];
  },
  setMyOrderFixtureList: (state, list = []) => {
    state.myOrder.list = [...list];
  },
  setMyOrderState: (state, { orderNo, orderState }) => {
    state.myOrder.list = state.myOrder.list.map((order) =>
      Number(order.orderNo) === Number(orderNo) ? { ...order, orderState } : order
    );
  },
  setMyOrderPageInfo: (
    state,
    pageInfo = { page: 1, totalPage: 2, limit: 10 }
  ) => {
    state.myOrder.pageInfo = pageInfo;
  },
  purgeMyOrder: (state) => {
    const list = [];
    const pageInfo = { page: 1, totalPage: 2, limit: 10 };
    state.myOrder.list = list;
    state.myOrder.pageInfo = pageInfo;
  },

  setMyOrderPage: (state, page) => (state.myOrder.pageInfo.page = page)
};
